import React from 'react';
import PropTypes from 'prop-types';

import Icon from './Icon';
import Box from '../Styled/Box';
import Typography from '../Typography/Typography';

const IconWithLabel = ({
  icon,
  label,
  iconProps,
  typographyProps,
  boxProps,
  children,
}) => (
  <Box display='flex' alignItems='center' {...boxProps}>
    <Icon icon={icon} {...iconProps} />

    <Typography ml={2} variant='helper' {...typographyProps}>{children || label}</Typography>
  </Box>
);

IconWithLabel.propTypes = {
  icon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]).isRequired,
  label: PropTypes.string,
  children: PropTypes.string,
  iconProps: PropTypes.object,
  typographyProps: PropTypes.object,
  boxProps: PropTypes.object,
};

IconWithLabel.defaultProps = {
  icon: 'question',
  label: '',
  children: 'Label',
  iconProps: {},
  typographyProps: {},
  boxProps: {},
};

export default IconWithLabel;
